
import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText } from '@wordpress/block-editor';
import './editor.scss';

export default function Edit(props) {
	const blockProps = useBlockProps({
		className: 'c4l-grading-value'
	});
	const { attributes, setAttributes } = props;
	const { content, grade } = attributes;

	return (
		<div {...blockProps}>
			<div className="c4l-grading-value-container">
				<RichText
					tagName='div'
					className='c4l-grading-value-content'
					value={content}
					onChange={(newVal) => setAttributes({ content: newVal })}
					placeholder={__('Grading Value:', 'grading-value')}
				/>
				<RichText
					tagName='div'
					className='c4l-grading-value-grade'
					value={grade}
					onChange={(newVal) => setAttributes({ grade: newVal })}
					placeholder={__('33%', 'grading-value')}
				/>
			</div>
		</div>
	);
}
